const getActionType = (reducerName, actionType) => {
    return `${reducerName}_${actionType}`;
};

export default getActionType;
